import { render, staticRenderFns } from "./kolEdit.vue?vue&type=template&id=7d2d2aa6&scoped=true&"
import script from "./kolEdit.vue?vue&type=script&lang=js&"
export * from "./kolEdit.vue?vue&type=script&lang=js&"
import style0 from "./kolEdit.vue?vue&type=style&index=0&id=7d2d2aa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2d2aa6",
  null
  
)

export default component.exports